const DEFAULTS = {
  config: {
    toolbar: {
      hidden: []
    }
  },
  configViewer: {
    getVideoUrl: (src) => `https://video.wixstatic.com/${src.pathname}`,
    getThumbnailUrl: (src) => {
      if (src.pathname.startsWith("media/")) {
        return `https://static.wixstatic.com/${src.pathname}`;
      }
      return `https://static.wixstatic.com/media/${src.pathname}`;
    }
  }
};
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    alignment: "CENTER",
    width: {
      size: "CONTENT"
    },
    textWrap: true
  }
});
export {
  DEFAULTS,
  RICOS_DEFAULTS
};
//# sourceMappingURL=defaults.js.map
